import { initContract } from "@ts-rest/core";
import { z } from "zod";
import type { CoAMappingExtraction } from "../types/financialDocument";
import { ErrorMessageSchema } from "@common/schemas/error.schema";
import { AccountClass } from "@common/constants/domains/accounting/accounts";
import { BalanceSheetExtractionSchema } from "../dto/financialDocument/balance-sheet-extraction.schema";
import { CoAAccountMappingSuggestionsSchema } from "../dto/financialDocument/coa-account-mapping.schema";
import {
    mapCoaTypesCsvBodySchema,
    mapCoaTypesCsvResponseSchema,
} from "../dto/financialDocument/coa-type-mapping.schema";

const c = initContract();

export interface ProcessCoADocumentResponse {
    success: boolean;
    accountMappings: CoAMappingExtraction;
}

export const fileScanningContract = c.router(
    {
        processCoADocument: {
            method: "POST",
            path: "/:entityId/process-coa-document/:documentId",
            pathParams: z.object({
                entityId: z.coerce.number(),
                documentId: z.coerce.number(),
            }),
            body: c.noBody(),
            responses: {
                200: c.type<ProcessCoADocumentResponse>(),
                400: ErrorMessageSchema,
            },
        },
        extractBalanceSheet: {
            method: "POST",
            path: "/:entityId/extract-balance-sheet/:documentId",
            pathParams: z.object({
                entityId: z.coerce.number(),
                documentId: z.coerce.number(),
            }),
            body: c.noBody(),
            responses: {
                200: BalanceSheetExtractionSchema,
                400: ErrorMessageSchema,
            },
        },
        mapAccountsToCoA: {
            method: "POST",
            path: "/:entityId/map-accounts-to-coa",
            pathParams: z.object({
                entityId: z.coerce.number(),
            }),
            body: z.object({
                accountNames: z.object({
                    [AccountClass.assets]: z.array(z.string()),
                    [AccountClass.liabilities]: z.array(z.string()),
                    [AccountClass.equity]: z.array(z.string()),
                    [AccountClass.income]: z.array(z.string()),
                    [AccountClass.expenses]: z.array(z.string()),
                }),
            }),
            responses: {
                200: CoAAccountMappingSuggestionsSchema,
                400: ErrorMessageSchema,
            },
        },
        mapCoaTypesCsv: {
            method: "POST",
            path: "/map-coa-types-csv",
            body: mapCoaTypesCsvBodySchema,
            responses: {
                200: mapCoaTypesCsvResponseSchema,
                400: ErrorMessageSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
    },
    {
        pathPrefix: "/fileScanning",
    },
);
